import axiosInstance from '../../../axiosInstance2'
import apiEndpoints from '../../../api'
import { notify } from '../../../../utils/notification'

/* =========================
   LIST COMMUNITIES
========================= */
export const getCommunityListReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
        search: searchQuery.search || '',
        status: searchQuery?.status,
        type: searchQuery?.type,

    };

    return axiosInstance.get(apiEndpoints.CTRL_COMMUNITY_LIST_API, {
        params
    })
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};


/* =========================
   CREATE COMMUNITY
========================= */
export const createCommunityReq = (action) => {
    const body = {
        ...action?.data,
        "status": "ACTIVE"
    };

    return axiosInstance.post(apiEndpoints.CTRL_CREATE_COMMUNITY_API, { ...body })
        .then(response => response)
        // Hand the error body back instead of toasting here — the saga shows one
        // toast and routes field errors (e.g. admin_email_domain) to the form.
        // Validation 400s come as { status, message } with no statusCode.
        .catch(errors => errors?.response?.data || { success: false, message: errors?.message || 'Something went wrong' });
};


/* =========================
   GET COMMUNITY DETAILS
========================= */
export const getCommunityDetailsReq = (action) => {
    return axiosInstance.get(
        `${apiEndpoints.CTRL_GET_COMMUNITY_DETAILS_API}/${action?.data?.id}`
    )
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};


/* =========================
   UPDATE COMMUNITY
========================= */
export const editCommunityReq = (action) => {
    // PATCH only touches what is sent — e.g. { status } alone changes just the
    // status — so keep the id and callbacks out of the body.
    // eslint-disable-next-line no-unused-vars
    const { id, onSuccess, onError, ...body } = action?.data || {};

    return axiosInstance.patch(`${apiEndpoints.CTRL_EDIT_COMMUNITY_API}/${id}`, body)
        .then(response => response)
        // Hand the error body back — the saga toasts once. Validation 400s come
        // as { status, message } with no statusCode.
        .catch(errors => errors?.response?.data || { success: false, message: errors?.message || 'Something went wrong' });
};


/* =========================
   DELETE COMMUNITY
========================= */
export const deleteCommunityReq = (action) => {
    return axiosInstance.delete(
        `${apiEndpoints.CTRL_DELETE_COMMUNITY_API}/${action?.data?.id}`
    )
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};
